module.exports = __webpack_public_path__ + "img/shipment-check.d0ee6d7f.svg";